<template>
  <div class="main">
    <div style="padding-bottom: 15px; text-align: center; width: 800px; display: none;">
        <span style="font-size: 25px">
          {{formTitle}}
        </span>
    </div>
    <div class="main2">
      <el-form ref="form" :model="form" :rules="rules" label-width="180px">
        <el-form-item label="应用名称" prop="应用名称" size="mini">
          <el-input v-model="form.应用名称" ref="应用名称" style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="备注" size="mini">
				  <el-input type="textarea" rows="6" v-model="form.备注" ref="备注" style="width:300px;"></el-input>
				</el-form-item>
				<el-row>
          <div style="text-align: center;">
          	<el-button ref="sendButton" type="primary" size="mini" @click="submitForm('form')" >{{sendButtonValue}}</el-button>
          	<el-button ref="sendButton2" type="warning" size="mini" @click="close('form')">取消</el-button>
          	
          </div>
        </el-row>
      </el-form>
      </div>
			
  </div>
</template>

<script>
  import * as util from "@/utils/util.js"
	
	export default {
    data() {
      return {
        form: {
          AutoID: '0',
          应用名称: '',
          备注: '',
					
        },
				OldValue:"",
        rules: {
          应用名称: [
            {required: true, message: '请输入应用名称', trigger: 'blur'}
          ],
					
        },
        sendButtonValue: '保存',
				formTitle: '修改应用',
				type:'',
				id:'0',
				loaded: false,
				
      }
    },
    methods: {
      submitForm(formName) {
				//console.log(this.labelList);
				//return;
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            //console.log(JSON.stringify(this.form));
            //alert('submit!');
						
						var url="/Handler/App.ashx?mode=edit";
						this.$ajax.post(url,this.form).then((response)=>{
						  //console.log(response.data);
						
						  let value=response.data;
						
						  let errorCode=value.errorCode;
						
						  if(errorCode=="0")
						  {
						    this.$message({
						      type: 'success',
						      message: '保存成功:'
						    });
						    
						    this.$store.dispatch('worktabRemoveNoBack', this.$route.name + '-' + this.$route.params.type);
						    
						    this.$router.push({path: '/app'});
						  }
						  else
						  {
						    let desc=value.desc;
						    this.$alert('保存失败：' +　desc, '系统提示', {
						      confirmButtonText: '确定',
						      callback: action => {
						    
						      }
						    });
						  }
						
						},function(err){
						  console.log(err);
						});

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      close(){
      	this.$store.dispatch('worktabRemoveNoBack', this.$route.name + '-' + this.$route.params.type);
      	
      	this.$router.push({path: '/app'});
      },
      requestAppData(){
      	let url="/Handler/App.ashx?mode=info";
      	this.loaded=false;
      	
      	let payload={
      		AutoID: this.id
      	}
      	
      	this.$ajax.post(url,payload).then(
      	  response => {
      	    //console.log(response.data);
      			let errorCode=response.data.errorCode;
      			
      			if(errorCode=='0'){
      				if(response.data.data.length>0){
      					this.form=JSON.parse(JSON.stringify(response.data.data[0]));
      					
      				}
      				else{
      					this.$alert('获取失败', '系统提示', {
      					  confirmButtonText: '确定',
      					  callback: action => {
      					
      					  }
      					});
      				}
      			}
      	    else{
      				let desc=value.desc;
      				this.$alert('获取失败：' +　desc, '系统提示', {
      				  confirmButtonText: '确定',
      				  callback: action => {
      				
      				  }
      				});
      			}
      			
      			//console.log(this.sltList);
      			setTimeout(()=>{
      				this.loaded=true;
      			},150);
      			
      	  },
      	  function(err) {
      	    console.log(err);
      			
      	  }
      	);
      	
      }
    },
    mounted(){
			this.id=this.$route.params.id;
			this.type=this.$route.params.type;
			
			this.form.AutoID=this.id;
			this.requestAppData();
			
    }
  }
</script>

<style lang="scss" scoped="scoped">
.sendButton {
	padding-left: 10px;
	padding-right: 10px;
	width: 80px;
}
.main2{
	padding: 10px;
	width: 800px;
	text-align: left;
}

</style>
<style>
  .demo {
    text-align: left;
  }
  .demo .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
  }
  /*打开时文字位置设置*/
  .demo .el-switch__label--right {
    z-index: 1;
    right: -8px;
  }
   /*关闭时文字位置设置*/
  .demo .el-switch__label--left {
    z-index: 1;
    left: 25px;

  }
  /*显示文字*/
  .demo .el-switch__label.is-active {
    display: block;
    color: #000000;
  }
  .demo .el-switch .el-switch__core,
  .demo .el-switch .el-switch__label {
    width: 50px !important;
  }
</style>